import { useMutation } from '@tanstack/react-query';
import { adminFetch } from './useAdminApi';

/**
 * usePaperInvoice — DocuPost single-invoice paper preview/send (superadmin).
 *
 * preview (default): renders + uploads the PDF, returns its signed URL. Does
 * NOT spend postage. send: also calls DocuPost + logs to orders.mail_log
 * (kind='invoice'). Mirrors usePaperStatement.
 */

interface MailTo {
  name: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
}

export interface PaperInvoicePreview {
  ok: true;
  mode: 'preview';
  pdf_url: string;
  to: MailTo;
  qbo_invoice_id: string;
  doc_number: string;
  total_amount: number;
  balance: number;
  line_count: number;
}

export interface PaperInvoiceSend {
  ok: boolean;
  mode: 'send';
  pdf_url: string;
  docupost: { status: number; raw: string; id: string | null };
  mail_log_id: string | null;
}

export type PaperInvoiceResult = PaperInvoicePreview | PaperInvoiceSend;

export interface PaperInvoiceInput {
  customer_id: string;
  qbo_invoice_id: string;
  mode: 'preview' | 'send';
}

export function usePaperInvoice() {
  return useMutation<PaperInvoiceResult, Error, PaperInvoiceInput>({
    mutationFn: (input) =>
      adminFetch<PaperInvoiceResult>('admin-send-paper-invoice', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
  });
}
